module.exports = __webpack_public_path__ + "static/holaspirit-logo.bb8d1768.svg";